import { Observable, Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SideBarService } from '../_services/side-bar.service';
import { MenuItem } from '../_models/MenuItem';
import { AccountService } from 'on-auth/_services/account.service';
import { DialogService } from 'on-common/_services/dialog.service';
import { Select } from '@ngxs/store';

import { CompanyState } from 'on-shared/stores/company/company.state';
import { Company } from 'on-shared/_models/Company';
import { CompanyService } from 'on-shared/stores/company/company.service';

@Component({
    selector: 'on-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit, OnDestroy {
    @Select(CompanyState.current) currentCompany$: Observable<Company>;

    sidebarSubsciption: Subscription;
    routeParamsSubsciption: Subscription;

    tree: MenuItem[] = null;
    appLogo: string;
    hasTree = false;
    isWhiteLabel = false;

    constructor(
        public sidebarService: SideBarService,
        public accountService: AccountService,
        public dialogService: DialogService,
        private companyService: CompanyService,
    ) {}

    ngOnInit() {
        this.currentCompany$.subscribe((company) => {
            this.isWhiteLabel = false;
            if (company?.IsUnderAccountantExpert) {
                this.companyService
                    .GetLogoUrl(company.Id)
                    .subscribe((logoUrl) => {
                        if (logoUrl?.IsSuccess && logoUrl.Result) {
                            this.appLogo = logoUrl.Result;
                            this.isWhiteLabel = true;
                        } else {
                            this.appLogo = '/assets/images/logo-200.png';
                        }
                    });
            } else if (company?.IsAccountantExpert) {
                this.appLogo = company.Settings.CompanyLogoUrl;
                this.isWhiteLabel = true;
            } else {
                this.appLogo = '/assets/logo-200.png';
            }
        });

        this.sidebarSubsciption = this.sidebarService.sibarTree.subscribe(
            (sbTree) => {
                if (sbTree) {
                    this.hasTree = true;
                    this.tree = sbTree;
                }
            },
        );
    }

    ngOnDestroy() {
        this.sidebarSubsciption.unsubscribe();
        this.routeParamsSubsciption.unsubscribe();
    }
}
